import styles from "./PersonMessage.module.less";
import CommonNavBar from "views/components/CommonNavBar";
import { useNavigate } from "react-router-dom";

const PersonMessage = () => {
  const navigate = useNavigate();
  const messageList = [
    {
      title: "一、用户基本信息",
      cellList: [
        {
          name: "手机号",
          purpose: "创建账号、更换账号。",
          scene: "首次注册创建账号、解绑更换账号。",
          content: "换绑手机号",
        },
        {
          name: "头像",
          purpose: "用户账号显示。",
          scene: "用户自行完善设置。",
          content: "账号管理",
        },
        {
          name: "昵称",
          purpose: "用户账号显示。",
          scene: "用户自行完善设置。",
          content: "账号管理",
        },
        {
          name: "性别",
          purpose: "用户账号显示。",
          scene: "用户自行完善设置。",
          content: "账号管理",
        },
        {
          name: "生日",
          purpose: "用户账号显示。",
          scene: "用户自行完善设置。",
          content: "账号管理",
        },
        {
          name: "收货地址",
          purpose: "寄送随材，积分兑换礼品。",
          scene: "用户自行完善设置。",
          content: "收货地址",
        },
      ],
    },
    {
      title: "二、数字内容服务信息",
      cellList: [
        {
          name: "通知运行权限",
          purpose: "为用户提供数字内容服务及通知。",
          scene: "用户使用数字内容时自动生成",
          content: "首页",
        },
        {
          name: "存储空间",
          purpose: "数字内容的互动与服务。",
          scene: "缓存文件，记录课程进度。",
          content: "教材",
        },
        {
          name: "麦克风权限",
          purpose: "数字内容的互动与服务。",
          scene: "用户给予权限后，数字内容中需要语音互动的场景。",
          content: "教材",
        },
        {
          name: "摄像头权限",
          purpose: "数字内容的互动与服务。",
          scene: "用户给予权限后，数字内容中需要视频互动的场景。",
          content: "教材",
        },
      ],
    },
    {
      title: "三、个人常用设备信息",
      cellList: [
        {
          name: "设备名称、最近登录时间",
          purpose: "用于排查定位问题，保障产品的安全和使用体验。",
          scene: "问题排查和风控安全保障。",
          content: "设备管理",
        },
      ],
    },
  ];
  return (
    <div className={styles["person-message-container"]}>
      <CommonNavBar
        backgroundColor="#fafafa"
        onClickBack={() => {
          navigate(-1);
        }}
      />
      <div className={styles["header-title"]}>个人信息收集清单</div>
      <div className={styles["header-desc"]}>
        为保障应用功能实现与安全稳定运行的目的，口袋领航可能会申请或使用操作系统的相关权限。为保障您的知情权，我们通过以下列表将产品可能申请、使用的相关操作系统权限进行展示，您可以根据实际需要对相关权限进行管理。
      </div>
      {messageList.map((item, index) => (
        <div className={styles["message-box"]} key={`${index}-message-box`}>
          <div className={styles["message-box-title"]}>{item.title}</div>
          {item.cellList.map((cell, index) => (
            <div className={styles["cell"]} key={`${index}-cell`}>
              <div
                className={styles["cell-bold"]}
              >{`信息名称：${cell.name}`}</div>
              <div
                className={styles["cell-normal"]}
              >{`使用目的：${cell.purpose}`}</div>
              <div
                className={styles["cell-normal"]}
              >{`使用场景：${cell.scene}`}</div>
              <div
                className={styles["cell-normal"]}
              >{`信息内容：${cell.content}`}</div>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default PersonMessage;
